/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchContainersPlaceResponse } from './search-containers-place-response';


export interface SearchContainersShelfResponse { 
    id: string;
    places: Array<SearchContainersPlaceResponse>;
}

